/*
  OKATA — integração com o CART DRAWER NATIVO do Dawn (não é um drawer custom).
  1) Ao adicionar um produto (form /cart/add), faz AJAX com a Section Rendering API
     (envia `sections` com o id da seção do drawer) e ABRE o drawer nativo via
     cart-drawer.renderContents() — que injeta o HTML retornado no #CartDrawer.
  2) FIX: o Dawn não remove a classe `is-empty` do elemento <cart-drawer> ao adicionar
     o 1º item (o CSS then esconde header/itens). Aqui garantimos o estado correto.
  3) Mantém o contador da sacola no header em sincronia (add/qtd/remover).
  As ações internas (qtd/remover) continuam sendo tratadas pelo Dawn.
*/
(function () {
  'use strict';

  function drawerEl() { return document.querySelector('cart-drawer'); }
  function setBadge(n) {
    var b = document.querySelector('[data-cart-count]');
    if (!b) return;
    b.textContent = n;
    if (n > 0) { b.hidden = false; } else { b.hidden = true; }
  }

  // Sincroniza contador do header + estado is-empty do drawer com o carrinho REAL
  function syncCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c || typeof c.item_count !== 'number') return;
        setBadge(c.item_count);
        var cart = drawerEl();
        if (cart) { cart.classList.toggle('is-empty', c.item_count === 0); }
      })
      .catch(function () {});
  }

  // 1) Interceptar "adicionar à sacola" => AJAX + abrir drawer nativo
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    var cart = drawerEl();
    if (!cart || typeof cart.renderContents !== 'function') return; // sem drawer => submit normal
    e.preventDefault();

    var fd = new FormData(form);
    if (!fd.get('id')) return;
    var sections = cart.getSectionsToRender ? cart.getSectionsToRender().map(function (s) { return s.id; }).join(',') : '';
    if (sections) { fd.append('sections', sections); fd.append('sections_url', window.location.pathname); }

    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-disabled', 'true');

    fetch('/cart/add', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) return; // erro (ex.: esgotado)
        cart.renderContents(res);           // injeta os itens + abre o drawer
        cart.classList.remove('is-empty');  // FIX: acabamos de adicionar => não está vazio
        syncCart();
      })
      .catch(function () {})
      .then(function () { if (btn) btn.removeAttribute('aria-disabled'); });
  });

  // 3) Botão "FINALIZAR COMPRA" do drawer => checkout da YAMPI.
  //    A rotina da Yampi que injeta o botão só roda na página /cart; o drawer aparece em
  //    todas as páginas. Por isso usamos a função GLOBAL da própria Yampi (definida no
  //    snippet YampiSnippet): window.yampiClick() consulta o /cart.json atual, pede o
  //    checkout_direct_url à Yampi e redireciona para seguro.okataeyewear.com.br — mesmo
  //    destino do botão da /cart. Delegado por id: sobrevive à re-renderização do drawer.
  //    Fallback: se a Yampi não estiver disponível, manda para /cart (onde o botão da Yampi existe).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#CartDrawer-Checkout');
    if (!btn) return;
    e.preventDefault();
    if (btn.hasAttribute('disabled')) return;
    if (typeof window.yampiClick !== 'function') {
      window.location.href = '/cart';
      return;
    }

    // REDE DE SEGURANÇA
    // window.yampiClick() faz duas chamadas em sequência (GET /cart.json e POST
    // para a API da Yampi) e só redireciona se a segunda responder exatamente 200.
    // Não há tratamento de erro nem timeout: se a API falhar, demorar ou responder
    // outro status, o loader fica girando e o cliente nunca chega ao checkout.
    //
    // O timer abaixo só chega a disparar se a navegação NÃO aconteceu, porque uma
    // navegação bem-sucedida destrói a página e o timer junto. Nesse caso mandamos
    // o cliente para /cart, onde existe o botão próprio da Yampi, em vez de deixá-lo
    // preso num spinner.
    window.yampiClick();
    setTimeout(function () {
      // Só socorre quem ainda está preso: se o loader da Yampi não estiver mais
      // visível, ou o cliente desistiu e fechou a sacola, ou a própria Yampi já
      // escondeu o loader. Nesses casos não mexemos na navegação dele.
      var loader = document.querySelector('.yampi-loader');
      var preso = loader && window.getComputedStyle(loader).display !== 'none';
      if (preso) { window.location.href = '/cart'; }
    }, 9000);
  });

  // 4) Sincronizar em qualquer mudança do drawer (qtd/remover) — mantém is-empty + contador corretos
  document.addEventListener('DOMContentLoaded', function () {
    var cart = drawerEl();
    if (!cart) return;
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(syncCart, 250);
    }).observe(cart, { childList: true, subtree: true });
  });
})();
